export const APP_NAME = 'NCAA Data Capture Portal';
export const APP_DESCRIPTION = 'Official Data Capture Portal for the Nigerian Civil Aviation Authority (NCAA)';
export const ORG_NAME = 'Nigeria Civil Aviation Authority';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  ADMIN: '/admin',
  ABOUT: '/about',
  CENTERS: '/centers',
  CONTACT: '/contact',
  REQUIREMENTS: '/requirements',
  TERMS: '/terms',
} as const;

export const USER_ROLES = {
  APPLICANT: 'APPLICANT',
  OPS: 'OPS',
  ADMIN: 'ADMIN',
} as const;

export const LICENSE_CATEGORIES = {
  PILOT: 'PILOT',
  CABIN_CREW: 'CABIN_CREW',
  FLIGHT_DISPATCHER: 'FLIGHT_DISPATCHER',
  AME: 'AME', // Aircraft Maintenance Engineer
  ATC: 'ATC', // Air Traffic Control
  ATSEP: 'ATSEP', // Air Traffic Safety Electronics Personnel
  ASO: 'ASO', // Aeronautical Station Operator
} as const;

export const LICENSE_TYPES = {
  NEW: 'NEW',
  RENEWAL: 'RENEWAL',
} as const;

export const LICENSE_CATEGORY_LABELS = {
  PILOT: 'Pilot License',
  CABIN_CREW: 'Cabin Crew License',
  FLIGHT_DISPATCHER: 'Flight Dispatcher License',
  AME: 'Aircraft Maintenance Engineer License (AME/MPL)',
  ATC: 'Air Traffic Controller License',
  ATSEP: 'Air Traffic Safety Electronics Personnel License',
  ASO: 'Aeronautical Station Operator License',
} as const;

export const APPLICATION_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  RETURNED: 'RETURNED',
} as const;

export const NIN_STATUS = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  FAILED: 'FAILED',
} as const;
